import React from 'react'
import { connect } from 'react-redux'
import { Box, Divider, TextField, Grid, Tooltip } from '@material-ui/core'
import { viewStyles } from '../styles/styles'
import RightPreviewPart from './RightPreviewPart'
import { changeNameElement, setFormName } from '../actions/settings'
import infoIcon from '../styles/images/info.png'
import { makeStyles } from '@material-ui/styles'
import CancelFormButton from '../containers/CancelFormButton'

const ViewSettings = ({ settings, changeValue, setFormName }) => {
    const classes = viewStyles()
    return (
        <Box className={classes.box_view}>
            <Box className={classes.leftBox} /*display="flex" flexDirection="column"*/>
                <Grid container spacing={1} justifyContent="flex-start">
                    <Grid item xs={10}>
                        <Box m="10px 0" className={classes.titleLeft}>Start setting up your form</Box>
                    </Grid>
                    <Grid item xs={7}>
                        
                        <TextField 
                                id="form-name" 
                                label="Form Name:"
                                value={settings.form.Name}
                                onChange={(e) => {setFormName(e.target.value)}} 
                                margin="normal"                        
                                placeholder="Contact Me"
                                className={classes.settingsFieldText}
                                fullWidth={true}
                        ></TextField>                      
                    </Grid>
                    <Grid item xs={7}>
                        <TextField 
                            id="email" 
                            label={<Label title="Email Addresses to Notify:" description="Separate multiple email recipients correctly with commas."></Label>}
                            value={settings.ownerEmail}
                            onChange={(e) => {changeValue(e.target.value, null, 'email')}} 
                            margin="normal"
                            className={classes.settingsFieldText}
                            fullWidth={true}
                            placeholder="user@user.com"
                        ></TextField>
                    </Grid>
                    <Grid item xs={7}>
                        <TextField 
                            id="success-message" 
                            label={<Label title="Submit Message:" description="Customize what happens when visitors submit your form."></Label>}
                            value={settings.successMessage}
                            onChange={(e) => {changeValue(e.target.value, null, 'message')}}
                            margin="normal"
                            className={classes.settingsFieldText} 
                            fullWidth={true}
                            placeholder="Success! Message received. Thank you."
                            multiline={true}
                            minRows={4}
                            maxRows={6}
                        ></TextField>
                    </Grid>
                    <Grid item xs={7}>
                    <TextField 
                            id="error-message" 
                            label={<Label title="Error Message:" description="Create error messages underneath your form."></Label>}
                            value={settings.errorMessage}
                            onChange={(e) => {changeValue(e.target.value, null, 'error')}}
                            margin="normal"
                            className={classes.settingsFieldText} 
                            fullWidth={true}
                            placeholder="An error has been encountered. Please try again."
                            multiline={true}
                            minRows={4}
                            maxRows={6}
                        ></TextField>
                    </Grid>
                </Grid> 
            </Box>
            <Box className={classes.bottomBox} m="5px 0 5px 0px">
                <Grid item xs={2}>
                    <CancelFormButton />
                </Grid>
            </Box>
            <Divider orientation="vertical" className={classes.devider}></Divider>
            <Box className={classes.rightBox}>
                <RightPreviewPart isShowPreview={false}></RightPreviewPart>
            </Box>                                  
        </Box>
    )
}

const useStylesInfoTooltip = makeStyles(() => ({
    arrow: {
      color: '#333'      
    },
    tooltip: {
      backgroundColor: '#fff',
      color: '#333',
      border: '#333 1px solid',
      borderRadius: 0,
      padding: '5px 10px',
      fontSize: 12,
      maxWidth: 130,
      fontFamily: 'Asap-Regular'
    }
}));

const InfoTooltip = (props) => {
    const classes = useStylesInfoTooltip()
    return (
        <Tooltip arrow classes={classes} {...props} />            
    )
}

const Label = ({title, description}) => {
    const classes = viewStyles()
    return (
        <div>
            <label>{title}</label>
            <InfoTooltip title={description} placement="right">
                <img className={classes.infoIcon} src={infoIcon} />
            </InfoTooltip>
        </div>
    )
}

const mapStateToProps = state => ({
    ...state
})

const mapDispatchToProps = dispatch => ({
    changeValue: (name, id, kind) => dispatch(changeNameElement(name, id, kind)),
    setFormName: name => dispatch(setFormName(name))
})

export default connect(mapStateToProps, mapDispatchToProps)(ViewSettings)